<template>
    <div>
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item> 测试数据与分析报告上传 </el-breadcrumb-item>
            <el-breadcrumb-item>申报人上传</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <!-- 搜索框 新增按钮-->
            <!-- <el-row class="row-search">
                <el-col class="el-col-user-add">
                    <el-input class="user-search" clearable placeholder="请输申报书信息（用空格分隔），支持模糊搜索" v-model="query">
                        <el-button slot="append" icon="el-icon-search" @click.prevent="queryProjectInfo()"></el-button>
                    </el-input>
                </el-col>
            </el-row> -->
            <!-- 申报书列表 -->
            <el-table :data="projectInfo" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="名称" width="280"></el-table-column>
                <el-table-column prop="category" label="类别" width="280">
                    <!-- <template slot-scope="scope">
              <div>{{scope.row.category}}</div>
            </template> -->
                </el-table-column>
                <el-table-column label="创建时间" width="120">
                    <template slot-scope="scope">{{
                        scope.row.create_time | fmtdate
                    }}</template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="90">
                    <template slot-scope="scope">
                        <div>{{ statusName(scope.row.status) }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                            @click="showFile(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-card v-show="fileVisible">

            <h3>课题相关文件</h3>
            <div class="div-file">
                <el-table :data="fileList" style="width: 551px" :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                                @click="getFileCode(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <h3>计划任务书</h3>
            <div class="div-file">
                <el-table :data="fileListSignAgreement" style="width:551px;"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                                @click="getFileCode(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- <h3>中期成果报告</h3>
            <div class="div-file">
                <el-table :data="fileListMiddleCheck" style="width:551px;"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                                @click="getFileCode(scope.row)">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <h3>结题验收材料</h3>
            <div class="div-file">
                <el-table :data="fileListFinalCheck" style="width:551px;"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                                @click="getFileCode(scope.row)">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div> -->
            <div class="div-file">
                <!-- 上传附件 -->
                <div>
                    <h3>文档要求：</h3>
                    <h3>1、文档要求：</h3>
                    <h4>测试数据与分析报告须包含pdf格式文档，便于专家查看</h4>
                    <h3>、图片与视频：</h3>
                    <h4>图片文件必须为png或jpg格式；视频文件必须为mp4格式</h4>
                </div>
                <div class="div-upload">
                    <input type="file" value="" class="input-upload" @change="uploadFileEdit">
                    <el-button type="primary" size="small" class="button-upload">上传附件
                        <i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                </div>
                <!-- 文件列表 -->
                <el-table :data="fileListTestData" border style="width:551px;"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                                @click="downloadFile(scope.row)"></el-button>
                            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                                @click="deleteFile(scope.row)">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

    </div>
</template>

<script>
//下载
import fileDownload from 'js-file-download'

export default {
    components: {},
    data() {
        return {
            userid: '',
            username: '',
            query: '', //查询条件
            projectInfo: [],
            projectStatus: [],
            projectInfoSelected: {}, //选中的课题
            fileVisible: false,
            fileList: [],
            fileListSignAgreement: [], //保密协议及计划任务书
            fileListTestData: [], //测试数据与分析报告
            fileListMiddleCheck: [], //中期检查
            fileListFinalCheck: [], //结题验收

        }
    },

    created() {
        this.userid = localStorage.getItem("userid")
        this.username = localStorage.getItem("username")
        this.getProjectInfo()
        this.getProjectStatus();
    },

    methods: {

        // 获取课题状态
        async getProjectStatus() {
            const res = await this.axios.get(`/projectStatus/`);
            if (res.status === 200) {
                this.projectStatus = res.data;
            } else {
                this.$message.warning("错误");
            }
        },
        // 获取课题信息
        async getProjectInfo() {
            const res = await this.axios.get(`/projectInfo/?leader=${this.userid}`)
            if (res.status === 200) {
                this.projectInfo = res.data.results
            } else {
                this.$message.warning("错误")
            }
        },

        //获取状态名称
        statusName(id) {
            name = "";
            this.projectStatus.forEach((s) => {
                if (s.s_id == id) {
                    name = s.status;
                }
            });
            return name;
        },

        // 显示文件card
        showFile(item) {
            this.fileVisible = true
            this.projectInfoSelected = item
            this.getFileList(item.pid)
        },

        // 上传文件
        uploadFileEdit(e) {
            // 判断课题状态，如果不是6/8/9，则不能上传文件
            if (this.projectInfoSelected.status != 6 && this.projectInfoSelected.status != 8 && this.projectInfoSelected.status != 9) {
                return this.$message.error('当前课题状态不能上传文件！')
            }
            // 判断文件类型
            // console.log(this.projectInfoSelected.status)
            // 判断文件类型
            // in 操作符只能判断对象变量
            let fileType = {
                pdf: "",
                jpg: "",
                png: "",
                mp4: "",
                doc: "",
                ocx: "",
            }
            if (e.target.files[0].name.slice(-3) in fileType) {
                // pass
            } else {
                return this.$message.error('请上传pdf、doc、docx、jpg、png、mp4格式的文件！')
            }
            let formData = new FormData();
            // 调用后台上传接口，pid为具体路径，要加一层，防止用户查询到课题文件，误操作删除
            let pid = this.projectInfoSelected.pid + '/测试数据与分析报告'
            let data = JSON.stringify({
                pid: pid
            })
            formData.append('file', e.target.files[0]);
            formData.append('data', data); // 上传文件的同时， 也可以上传其他数据
            let url = `/uploadFile/`;
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            // 使用loading加载，客户等待
            const loading = this.$loading({
                lock: true, //lock的修改符--默认是false
                text: 'Loading', //显示在加载图标下方的加载文案
                spinner: 'el-icon-loading', //自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)', //遮罩层颜色
                target: document.querySelector('#table') //loadin覆盖的dom元素节点
            })
            this.axios.post(url, formData, config).then((response) => {
                this.getFileList(this.projectInfoSelected.pid)
                //成功回调函数停止加载遮罩
                loading.close()
            })
        },

        // 获取附件列表
        async getFileList(pid) {
            this.fileList = []
            this.fileListSignAgreement = []
            this.fileListMiddleCheck = []
            const res = await this.axios.get(`/fileList/?pid=${pid}`)
            if (res.status === 200) {
                this.fileList = res.data.results
            } else {
                this.$message.warning("获取文件列表错误")
            }
            // 保密协议、计划任务书
            const resAgreement = await this.axios.get(`/fileList/?pid=${pid}` + '/保密协议及计划任务书')
            if (resAgreement.status === 200) {
                let files = resAgreement.data.results
                this.fileListSignAgreement = []
                for (let i = 0; i < files.length; i++) {
                    // 如果名称包含“计划任务书”，则添加到fileListSignAgreement
                    if (files[i].name.includes("计划任务书")) {
                        this.fileListSignAgreement.push(files[i])
                    }
                }
            } else {
                this.$message.warning("获取文件列表错误")
            }
            // 测试数据与分析报告
            const resTest = await this.axios.get(`/fileList/?pid=${pid}` + '/测试数据与分析报告')
            if (resTest.status === 200) {
                this.fileListTestData = resTest.data.results
            } else {
                this.$message.warning("获取文件列表错误")
            }
            // 中期检查
            const resMiddle = await this.axios.get(`/fileList/?pid=${pid}` + '/中期检查阶段成果报告')
            if (resMiddle.status === 200) {
                this.fileListMiddleCheck = resMiddle.data.results
            } else {
                this.$message.warning("获取文件列表错误")
            }
            // 结题验收
            const resFinal = await this.axios.get(`/fileList/?pid=${pid}` + '/结题材料')
            if (resFinal.status === 200) {
                this.fileListFinalCheck = resFinal.data.results
            } else {
                this.$message.warning("获取文件列表错误")
            }
        },


        // 删除文件
        async deleteFile(item) {
            let res = await this.axios.delete('/fileList/' + item.id + '/')
            if (res.status === 204) {
                this.getFileList(this.projectInfoSelected.pid)
            }
            let data = {
                path: item.path
            }
            let resDelete = await this.axios.post('/deleteFile/', data)
            // console.log(resDelete)
        },

        // 下载文件
        downloadFile(item) {
            console.log('下载：', item)
            // 注意：path里带有文件名
            let url = `/downloadFile/?path=${item.path}&name=${item.name}`
            let params = {
                path: item.path,
                name: item.name
            }
            this.axios.post(url, params, {
                responseType: 'arraybuffer'
            }).then(res => {
                fileDownload(res.data, item.name)
            })
        },

    },
}

</script>

<style lang="less">
.el-card {
    margin-top: 15px;
}

.header-edit {
    font-size: 18px;
    text-align: left;
    margin-bottom: 10px;
}

.el-col-user-add {
    display: flex;
}

.user-search {
    width: 420px;
    margin-right: 10px;
}

.el-col-addForm {
    display: flex;
    margin-bottom: 10px;

    span {
        display: flex;
        align-items: center;
        margin-left: 10px;
    }

    .el-input {
        width: 400px;
    }
}



.el-row-detail {
    width: 1020px;

    .el-col {
        display: flex;

        span {
            display: flex;
            align-items: center;
            margin-left: 10px;
        }

        .el-input {
            width: 200px;
        }
    }
}


.div-upload {
    width: 500px;
    padding-top: 10px;
}

.div-add {
    margin-top: 20px;
    display: flex;
    justify-content: end;
}

.div-file {
    margin-top: 15px;

    .div-file-template {
        margin-bottom: 10px;
    }

    .div-upload {
        height: 47px;

        .input-upload {
            width: 101px;
            height: 33px;
            position: absolute;
            z-index: 1;
            opacity: 0;
        }

        .button-upload {
            position: absolute;
        }

        .button-upload:hover {
            cursor: pointer;
        }
    }
}

.button-commit {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/testReportUpload/TestReportUpload.vue